import React, { Component } from 'react';
// import classNames from 'classnames/bind';

class Adsense970250 extends Component {

  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {
    const style = {
      textAlign: 'center',
      verticalAlign: 'middle'
    }

    return (
      <div style={style}>
        <ins className="adsbygoogle ad970250"
          style={{display:'inline-block', width:'970px', height:'250px'}}
          data-ad-client="ca-pub-1407998984163880"
          data-ad-slot="6481725676"
        ></ins>
      </div>
    );
  }
}

export default Adsense970250;